import React from "react";
import _ from "lodash";
import TextArea from "./TextArea";

const TableBody = ({ data, columns, idColumn, selectedId, setSelectedId }) => {
  const renderCell = (item, column) => {
    if (column.content) return column.content(item);

    return _.get(item, column.path);
  };

  const createKey = (item, column) => {
    return item[idColumn || "_id"] + (column.path || column.key);
  };

  return (
    <tbody>
      {data.map((item, index) => (
        <React.Fragment key={`tr${index}`}>
          <tr
            onClick={
              setSelectedId
                ? () => {
                  if (selectedId === item[idColumn])
                    setSelectedId && setSelectedId("");
                  else setSelectedId && setSelectedId(item[idColumn]);
                }
                : undefined
            }
          >
            {columns.map((column) =>
              !column.hideColumn ? (
                <td key={createKey(item, column)}>
                  {renderCell(item, column)}
                </td>
              ) : null
            )}
          </tr>
          {selectedId && item[idColumn] === selectedId && (
            <>
              <tr className="bg-warning p-3">
                <td colSpan={columns.length}>
                  <i
                    className="text-danger fas fa-times pe-2"
                    onClick={() => {
                      setSelectedId("");
                    }}
                  ></i>
                  {item.logExceptionType}:
                  <br />"{item.logResponseMessage}"
                </td>
              </tr>
              <tr className="bg-danger p-3">
                <td colSpan={columns.length}>
                  {" "}
                  <TextArea
                    value={JSON.stringify(item, null, 4)}
                    disabled
                  />
                </td>
              </tr>
            </>
          )}
        </React.Fragment>
      ))}
    </tbody>
  );
};

export default TableBody;
